// DevHub: tier badge — shows "Partner" for all external users (simplified from
// a 3-tier system). Extracted from Root.tsx.
import { EXTERNAL_GROUP } from './navConfig';

export function TierBadge({ groups }: { groups: string[] }) {
  const isExternal = groups.includes(EXTERNAL_GROUP);
  if (!isExternal) return null;

  return <span className="devhub-tier-badge devhub-tier-badge--partner">Partner</span>;
}
